const ARCHIVE_DATE_FMT = new Intl.DateTimeFormat(undefined, {
	month: "short",
	day: "numeric",
	year: "numeric",
	timeZone: "UTC",
});

/** What the weather panel withholds for a range that starts before history: the shift's total, or
 *  the lookback's figures. */
const WITHHELD = {
	shift: "No shift total",
	lookback: "No lookback totals",
} as const;

/** "No lookback totals before Jan 1, 2025, when precipitation history starts." when a range
 *  starting at `rangeStart` reaches back before `archivedFrom` (the ISO UTC day precipitation
 *  history begins): its hours there have no data, which a total would read as "dry", so the panel
 *  withholds the `scope`'s figures and says why. Null when it doesn't, or while `archivedFrom` is
 *  unknown. */
export function precipHistoryNotice(
	archivedFrom: string | null,
	rangeStart: Date,
	scope: keyof typeof WITHHELD,
): string | null {
	if (!archivedFrom) return null;
	const archiveStart = new Date(`${archivedFrom}T00:00:00Z`);
	if (rangeStart.getTime() >= archiveStart.getTime()) return null;
	return `${WITHHELD[scope]} before ${ARCHIVE_DATE_FMT.format(archiveStart)}, when precipitation history starts.`;
}
